import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getStatementStatus'
})
export class GetStatementStatusPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    let status = 'Fuertemente en desacuerdo';
    if (value === null) return status;
    switch (value) {
      case 1:
        status = 'Fuertemente en desacuerdo';
        break;
      case 2:
        status = 'Moderadamente en desacuerdo';
        break;
      case 3:
        status = 'Medianamente en desacuerdo';
        break;
      case 4:
        status = 'Medianamente de acuerdo';
        break;
      case 5:
        status = 'Moderadamente de acuerdo';
        break;
      case 6:
        status = 'Fuertemente de acuerdo';
        break;
    }
    return status;
  }

}
